import styled from 'styled-components';
import { sharedInputStyles } from './sharedInputStyles';

const InputContainerWrapper = styled.div.withConfig({
  shouldForwardProp: (prop) =>
    prop !== 'error' && prop !== '$styleType' && prop !== 'hideButtons',
})`
  ${sharedInputStyles}
  width: ${({ $styleType }) => ($styleType === 'date' ? '' : '100%')};
`;

export default InputContainerWrapper;
